// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__1d29k","Main":"Index_Main__1b7KR"};